module.exports = __webpack_public_path__ + "img/an.d1b6db07.svg";